import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_ASIA_PROD } from "../consts.js"

export const coverHealth = {
	"coverHealth-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_ASIA_PROD }
}
